<script setup lang="ts">
import type { VNode } from "vue";
import type { Props as ButtonProps } from "../Button/index.vue";

function wrap(vnodes: VNode[]): VNode[] {
  const children: VNode[] = vnodes.map((child, index) => {
    const isFirst = index === 0;
    const isLast = index === vnodes.length - 1;
    const rounded = isFirst ? "left" : isLast ? "right" : false;
    const props: ButtonProps = {
      isGroup: true,
      rounded,
      ...child.props,
    };
    return {
      ...child,
      props,
    };
  });
  return children;
}
</script>

<template>
  <div
    class="ui-button-group inline-flex gap-x-0 overflow-hidden rounded-lg border border-primary-200 dark:border-primary-900"
  >
    <component
      :is="child"
      v-for="(child, idx) in wrap($slots.default?.() || [])"
      :key="idx"
    />
  </div>
</template>
